import React from 'react'
import { Link } from 'react-router-dom'
import PageLayout from '../../../components/layouts/PageLayout'
import SectionHeading from '../../../components/Heading'
import { withNamespaces } from 'react-i18next'

export const View = props => {
	const { t } = props
	return <PageLayout>
		<div className='c-content'>
			<div className='o-wrapper u-padding-vertical'>
				<div className='o-layout o-layout--center'>
					<div className='o-layout__item u-text--center u-1/1'>
						<SectionHeading text={t('page404.title')} />
						<p>{t('page404.text')}</p>
						<Link className='o-block' to='/'><span className='c-btn c-btn--finch'>{t('general.homeBtn')}</span></Link>
					</div>
				</div>
			</div>
		</div>
	</PageLayout>
}

export default withNamespaces()(View)



// WEBPACK FOOTER //
// ./src/routes/Error/components/View.js